import {
  CreateRedeemRequest,
  GetLoyaltyEventsResponse,
  LoyaltyUser,
  Redeem,
  ReferralConfig,
} from '@winelivery-org/wl-client-sdk-js';
import { getApisRoot, getHeaders } from '../common';

const baseUrl = getApisRoot('wl-loyalty-service', 'loyalty');

export const getLoyaltyUser = async (id: string) => {
  const response = await fetch(`${baseUrl}/v1/users/${id}`, {
    method: 'GET',
    headers: await getHeaders(),
  });

  const data = await response.json();

  return { ok: response.ok, status: response.status, data };
};

export const getPrize = async (id: number) => {
  const response = await fetch(`${baseUrl}/v1/prizes/${id}`, {
    method: 'GET',
    headers: await getHeaders(),
  });

  const data = await response.json();

  return { ok: response.ok, status: response.status, data };
};

export const getPrizes = async (page: number) => {
  const response = await fetch(`${baseUrl}/v1/prizes/?page=${page}`, {
    method: 'GET',
    headers: await getHeaders(),
  });

  const data = await response.json();

  return { ok: response.ok, status: response.status, data };
};

export const getEventsByUser = async (userId: string) => {
  const response = await fetch(
    `${baseUrl}/v1/users/${userId}/loyalty-events/`,
    {
      method: 'GET',
      headers: await getHeaders(),
    },
  );

  const data = (await response.json()) as
    | GetLoyaltyEventsResponse
    | { status_code: string };

  return { ok: response.ok, status: response.status, data };
};

export const createRedeem = async (body: CreateRedeemRequest) => {
  const response = await fetch(`${baseUrl}/v1/redeems/`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: await getHeaders(),
  });

  const data = (await response.json()) as Redeem;

  return { ok: response.ok, status: response.status, data };
};

export const getReferralConfig = async () => {
  const response = await fetch(`${baseUrl}/v1/referral/config`, {
    method: 'GET',
    headers: await getHeaders(),
  });

  const data = (await response.json()) as ReferralConfig;

  return { ok: response.ok, status: response.status, data };
};

export const registerToReferralProgram = async (userId: string) => {
  const response = await fetch(`${baseUrl}/v1/users/${userId}/referral`, {
    method: 'POST',
    headers: await getHeaders(),
  });

  const data = (await response.json()) as LoyaltyUser;

  return { ok: response.ok, status: response.status, data };
};
